"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hasRole = _interopRequireDefault(require("./permission/hasRole"));
var _hasPermi = _interopRequireDefault(require("./permission/hasPermi"));
var _drag = _interopRequireDefault(require("./dialog/drag"));
var _dragWidth = _interopRequireDefault(require("./dialog/dragWidth"));
var _dragHeight = _interopRequireDefault(require("./dialog/dragHeight"));
var _copy = _interopRequireDefault(require("./copy/copy"));
var _longpress = _interopRequireDefault(require("./longpress/longpress"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var install = function install(Vue) {
  Vue.directive('hasRole', _hasRole.default);
  Vue.directive('hasPermi', _hasPermi.default);
  Vue.directive('dialogDrag', _drag.default);
  Vue.directive('dialogDragWidth', _dragWidth.default);
  Vue.directive('dialogDragHeight', _dragHeight.default);
  Vue.directive('copy', _copy.default); //v-copy 复制指令
  Vue.directive('longpress', _longpress.default); //v-longpress 长按指令
};
if (window.Vue) {
  window['hasRole'] = _hasRole.default;
  window['hasPermi'] = _hasPermi.default;
  Vue.use(install); // eslint-disable-line
}
var _default = exports.default = install;